import { Box, Grid, IconButton, Typography } from "@mui/material"
import { createTheme, Theme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { ReactElement } from "react";

const defaultTheme = createTheme();

const useStyles = makeStyles(
    (theme: Theme) =>
        createStyles({
            root: {
                width: "100%",
                padding: "8px 16px",
                justifyContent: "space-between",
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                border: "none",
            },
        }),
    { defaultTheme }
);

export type SimpleToolbarProps = {
    title?: string | ReactElement,
    onBack?: () => void
    rightSlot?: () => React.ReactNode
}

export default function SimpleToolbar({
    title,
    onBack,
    rightSlot
}: SimpleToolbarProps) {
    const classes = useStyles();
    return (
        <Grid container className={classes.root}>
            <Grid size={6}>
                <Box component="div" sx={{ display: "flex", alignItems: "center" }}>
                    {onBack && (
                        <IconButton onClick={onBack} sx={{ marginRight: "8px" }}>
                            <ChevronLeftIcon />
                        </IconButton>
                    )}
                    {title && (
                        <Typography variant="h4" sx={{ textAlign: "left" }}>
                            {title}
                        </Typography>
                    )}
                </Box>
            </Grid>
            <Grid size={6}>
                <>
                    {rightSlot && rightSlot()}
                </>
            </Grid>
        </Grid>
    )
}